import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Search.svg'
import _imports_1 from '../library/assets/cart.png'
import _imports_2 from '../library/assets/Trash.png'
import _imports_3 from '../library/assets/Close_square.png'
import _imports_4 from '@/assets/icons/directory.svg'


const _withScopeId = n => (_pushScopeId("data-v-acb05a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asahi-bs-nav navbar sticky-bottom hidden-lg-up" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row g-0 w-fill" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-fixed-width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "bottom-search",
    "data-bs-target": "#searchModalNav",
    "data-bs-toggle": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Search icon"
    })
  ])
], -1))
const _hoisted_5 = { class: "col col-fixed-width" }
const _hoisted_6 = { class: "col col-fixed-width" }
const _hoisted_7 = { class: "col col-fixed-width" }
const _hoisted_8 = { class: "asahi-quantity-cart-container" }
const _hoisted_9 = {
  key: 0,
  class: "asahi-address-icon",
  src: _imports_1,
  alt: "Cart icon"
}
const _hoisted_10 = {
  key: 1,
  class: "asahi-address-icon",
  src: _imports_1,
  alt: "Cart icon"
}
const _hoisted_11 = {
  key: 2,
  class: "asahi-cart-quantity"
}
const _hoisted_12 = { class: "asahi-container" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "asahi-product-container" }
const _hoisted_15 = { class: "asahi-label-container" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "asahi-quantity-container"
}
const _hoisted_19 = {
  key: 0,
  class: "asahi-quantity-item"
}
const _hoisted_20 = { class: "asahi-unit" }
const _hoisted_21 = { class: "asahi-unit" }
const _hoisted_22 = {
  key: 1,
  class: "asahi-quantity-item"
}
const _hoisted_23 = { class: "asahi-unit" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "asahi-trash-icon",
  src: _imports_2,
  alt: "Trash icon"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "asahi-cart-buttons-container" }
const _hoisted_28 = { class: "asahi-remove-container" }
const _hoisted_29 = { class: "asahi-cancel" }
const _hoisted_30 = { class: "asahi-remove-container" }
const _hoisted_31 = { class: "asahi-go-to-cart" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-fixed-width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "navbar-toggler bottom-nav",
    "data-bs-target": "#menuModalNav",
    "data-bs-toggle": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
  ])
], -1))
const _hoisted_33 = {
  class: "modal",
  id: "searchModalNav",
  "aria-hidden": "true",
  "aria-labelledby": "searchModalNavLabel",
  tabindex: "-1"
}
const _hoisted_34 = { class: "modal-dialog modal-dialog-scrollable modal-fullscreen" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-body" }
const _hoisted_37 = { class: "modal-body-header" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Search icon"
}, null, -1))
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = {
  key: 0,
  class: "asahi-search-results-nav"
}
const _hoisted_41 = {
  key: 1,
  class: "container"
}
const _hoisted_42 = { class: "row justify-content-center" }
const _hoisted_43 = { class: "col-12 col-lg-10" }
const _hoisted_44 = {
  key: 0,
  class: "asahi-history"
}
const _hoisted_45 = { class: "asahi-search-results-container" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "asahi-search-results-container" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "asahi-search-results-item" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "d-flex d-lg-none justify-content-center" }
const _hoisted_54 = { class: "asahi-search-results-container" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = {
  key: 0,
  class: "asahi-search-results-item"
}
const _hoisted_57 = { class: "asahi-search-results-item-img" }
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 1,
  alt: "placeholder",
  src: _imports_4
}
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = {
  key: 2,
  class: "fw-bold d-flex justify-content-center mb-4"
}
const _hoisted_62 = {
  class: "modal",
  id: "menuModalNav",
  "aria-hidden": "true",
  "aria-labelledby": "menuModalNavLabel",
  tabindex: "-1"
}
const _hoisted_63 = { class: "modal-dialog modal-dialog-scrollable modal-fullscreen" }
const _hoisted_64 = { class: "modal-content" }
const _hoisted_65 = { class: "modal-body" }
const _hoisted_66 = { class: "modal-body-header" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_68 = { class: "col asahi-bs-nav-accordion" }
const _hoisted_69 = {
  class: "accordion",
  id: "asahi-bs-nav-accordion"
}
const _hoisted_70 = {
  key: 0,
  class: "accordion-header"
}
const _hoisted_71 = { class: "accordion-header" }
const _hoisted_72 = ["onClick", "data-bs-target", "aria-controls"]
const _hoisted_73 = ["id"]
const _hoisted_74 = { class: "accordion-body" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["href"]
const _hoisted_77 = { key: 2 }
const _hoisted_78 = {
  key: 0,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiUserIconAlt = _resolveComponent("AsahiUserIconAlt")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AsahiFavoriteIconAlt = _resolveComponent("AsahiFavoriteIconAlt")!
  const _component_AsahiProgressBar = _resolveComponent("AsahiProgressBar")!
  const _component_AsahiLoaderCard = _resolveComponent("AsahiLoaderCard")!
  const _component_AsahiHistoryIcon = _resolveComponent("AsahiHistoryIcon")!
  const _component_slide = _resolveComponent("slide")!
  const _component_AngleLeftRightIcon = _resolveComponent("AngleLeftRightIcon")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_ResizeObserver = _resolveComponent("ResizeObserver")!
  const _component_AsahiTabs = _resolveComponent("AsahiTabs")!
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/my-profile/details" }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomButton, {
                  options: _ctx.rightMenu,
                  selected: _ctx.$route.fullPath === '/my-profile/details' || _ctx.$route.fullPath === '/my-profile/company' || _ctx.$route.fullPath === '/my-profile/management'
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_AsahiUserIconAlt)
                  ]),
                  "hover-icon": _withCtx(() => [
                    _createVNode(_component_AsahiUserIconAlt)
                  ]),
                  _: 1
                }, 8, ["options", "selected"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CustomButton, {
              "pop-up-type": 'no-pop-up',
              "icon-quantity": _ctx.favoriteItem,
              selected: _ctx.$route.fullPath === '/catalog/favorites',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToFavourites()))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_AsahiFavoriteIconAlt)
              ]),
              "hover-icon": _withCtx(() => [
                _createVNode(_component_AsahiFavoriteIconAlt)
              ]),
              _: 1
            }, 8, ["icon-quantity", "selected"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/cart" }, {
              default: _withCtx(() => [
                (_ctx.catalogPermission)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["asahi-cart-container", { 'asahi-cart-container-open': _ctx.openCart || _ctx.$route.fullPath === '/cart' }]),
                      onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openCart = true)),
                      onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCart = false))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (!_ctx.openCart)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                          : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                        (_ctx.cartNumber > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.cartNumber), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.openCart)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "asahi-items-container",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCart = true))
                            }, [
                              (_ctx.query && _ctx.query.progress_bar_data)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_AsahiProgressBar)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItem, (items) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "asahi-cart-items",
                                    key: items.id
                                  }, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("a", {
                                          href: `/catalog/${items.product?.sku}`
                                        }, [
                                          _createElementVNode("img", {
                                            class: "asahi-items-image",
                                            src: items.product.image.url,
                                            alt: "Product image"
                                          }, null, 8, _hoisted_17)
                                        ], 8, _hoisted_16)
                                      ]),
                                      (_ctx.isTruckAvailable)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createTextVNode(_toDisplayString(items.product.name) + " ", 1),
                                            (!_ctx.isTruck)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                  _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('Units')), 1),
                                                    _createElementVNode("div", null, _toDisplayString(items.quantity_total), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('Layer')) + " (" + _toDisplayString(items.product.number_of_products_on_layer) + " " + _toDisplayString(_ctx.$t('Units')) + ")", 1),
                                                    _createElementVNode("div", null, _toDisplayString(items.number_of_layer), 1)
                                                  ])
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                  _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('Pallets')), 1),
                                                    _createElementVNode("div", null, _toDisplayString(items.number_of_pallet), 1)
                                                  ])
                                                ]))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.removeProductFromCart(items.id))
                                      }, _hoisted_26, 8, _hoisted_24)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", {
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeAllCartItems && _ctx.removeAllCartItems(...args)))
                                  }, [
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('Remove All')), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_router_link, { to: "/cart" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('Go To Cart')), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 34))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _hoisted_32
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-container", {'full-input-search': _ctx.searchInputActive}]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearchOpen()))
              }, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "search-content",
                  placeholder: _ctx.searchInputActive ? _ctx.searchKeyword : _ctx.$t('Search'),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchValue) = $event)),
                  onKeyup: [
                    _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearchType())),
                    _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.doSearchOnEnter()), ["enter"]))
                  ]
                }, null, 40, _hoisted_39), [
                  [_vModelText, _ctx.searchValue]
                ]),
                (_ctx.searchActive)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: "Close-icon",
                      src: _imports_3,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSearchReset()))
                    }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: "btn-cancel",
                "data-bs-dismiss": "modal",
                "aria-label": "Cancel",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSearchClose()))
              }, _toDisplayString(_ctx.$t('Cancel')), 1)
            ]),
            (_ctx.searchActive && _ctx.searchHistory?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_AsahiLoaderCard, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            (_ctx.searchValue?.length < 3 && _ctx.searchHistory?.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Search')) + " " + _toDisplayString(_ctx.$t('History')), 1),
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("ul", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHistory, (keyword) => {
                                        return (_openBlock(), _createElementBlock("li", { key: keyword }, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            onClick: ($event: any) => (_ctx.redoSearch(keyword))
                                          }, [
                                            _createVNode(_component_AsahiHistoryIcon),
                                            _createTextVNode(" " + _toDisplayString(keyword), 1)
                                          ], 8, _hoisted_46)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Products')), 1),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createVNode(_component_carousel, _mergeProps({
                                        ref: "productsCarousel",
                                        modelValue: _ctx.currentSlide,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentSlide) = $event))
                                      }, _ctx.settings, {
                                        breakpoints: _ctx.breakpoints,
                                        onSlideStart: _ctx.handleSlideStart,
                                        onInit: _ctx.handleInit
                                      }), {
                                        addons: _withCtx(() => [
                                          _createElementVNode("button", {
                                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
                                            class: _normalizeClass(["carousel__prev navigation-prev d-none d-md-flex", { disabled: _ctx.isDisabledPrev }]),
                                            disabled: _ctx.isDisabledPrev
                                          }, [
                                            _createVNode(_component_AngleLeftRightIcon, {
                                              right: false,
                                              class: "primary-gold angle-16"
                                            })
                                          ], 10, _hoisted_51),
                                          _createElementVNode("button", {
                                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                                            class: _normalizeClass(["carousel__next navigation-next d-none d-md-flex", { disabled: _ctx.isDisabledNext }]),
                                            disabled: _ctx.isDisabledNext
                                          }, [
                                            _createVNode(_component_AngleLeftRightIcon, {
                                              right: true,
                                              class: "primary-gold angle-16"
                                            })
                                          ], 10, _hoisted_52),
                                          _createElementVNode("div", _hoisted_53, [
                                            _createVNode(_component_Pagination, {
                                              class: "d-flex pagination my-2",
                                              ref: "pagination"
                                            }, null, 512)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
                                            return (_openBlock(), _createBlock(_component_slide, {
                                              key: item.id,
                                              class: "col-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_49, [
                                                  _createElementVNode("div", {
                                                    class: "asahi-search-results-item-img",
                                                    style: _normalizeStyle({ backgroundImage: 'url(' + item?.small_image.url + ')' })
                                                  }, null, 4),
                                                  _createElementVNode("p", null, [
                                                    _createElementVNode("span", {
                                                      innerHTML: item?.name?.replace(RegExp('(' + _ctx.searchHistory[0] + ')', 'gi'), '<b>$1</b>')
                                                    }, null, 8, _hoisted_50)
                                                  ]),
                                                  _createElementVNode("p", null, [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('Your price with VAT')) + " ", 1),
                                                    _createElementVNode("b", null, _toDisplayString(item?.your_price_tax), 1)
                                                  ])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 16, ["modelValue", "breakpoints", "onSlideStart", "onInit"]),
                                      _createVNode(_component_ResizeObserver, { onResize: _ctx.onResizePortal }, null, 8, ["onResize"])
                                    ])
                                  ]),
                                  _createElementVNode("h6", null, _toDisplayString(_ctx.$t('Marketing materials')), 1),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marketingMaterialsFiles, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          class: "col-6"
                                        }, [
                                          (index < 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                _createElementVNode("div", _hoisted_57, [
                                                  (item?.file?.link)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        alt: "link-img",
                                                        src: item?.file?.link
                                                      }, null, 8, _hoisted_58))
                                                    : (_openBlock(), _createElementBlock("img", _hoisted_59))
                                                ]),
                                                _createElementVNode("p", null, [
                                                  _createElementVNode("span", {
                                                    innerHTML: item?.name?.replace(RegExp('(' + _ctx.searchHistory[0] + ')', 'gi'), '<b>$1</b>')
                                                  }, null, 8, _hoisted_60)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.searchValue?.length >= 3 && _ctx.visibleTabs.length > 0)
                              ? (_openBlock(), _createBlock(_component_AsahiTabs, {
                                  key: 1,
                                  tabs: _ctx.visibleTabs,
                                  currentTab: _ctx.currentTab,
                                  onTabChanged: _ctx.onTabChanged,
                                  searchValue: _ctx.searchValue,
                                  onEmitChildMethod: _ctx.closeModal,
                                  pdpTabs: true
                                }, null, 8, ["tabs", "currentTab", "onTabChanged", "searchValue", "onEmitChildMethod"]))
                              : _createCommentVNode("", true),
                            (_ctx.visibleTabs.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.$t('No Result Found')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchInputActive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "asahi-search-results-backdrop",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSearchClose()))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_AsahiLogoNew, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hideModal()))
              }),
              _hoisted_67
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "accordion-item",
                    key: value.name
                  }, [
                    (value.name === 'products_catalogue')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["accordion-button", {'no-arrow': !value.children || value.children.length === 0}])
                          }, [
                            _createVNode(_component_router_link, {
                              to: _ctx.getRoutingPath(value.children, value.name),
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.hideModal()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(value.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ], 2)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", {
                              class: "accordion-button",
                              onClick: (event) => _ctx.toggleAccordion(event, index),
                              "data-bs-toggle": "collapse",
                              "data-bs-target": '#asahi-bs-nav-accordion-collapse-' + index,
                              "aria-expanded": "true",
                              "aria-controls": 'asahi-bs-nav-accordion-collapse-' + index
                            }, [
                              _createElementVNode("div", null, _toDisplayString(this.$t(value.name)), 1)
                            ], 8, _hoisted_72)
                          ]),
                          _createElementVNode("div", {
                            id: 'asahi-bs-nav-accordion-collapse-' + index,
                            class: "accordion-collapse collapse show"
                          }, [
                            _createElementVNode("div", _hoisted_74, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.children, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.name,
                                  onClick: ($event: any) => (_ctx.handleMenuClick(item))
                                }, [
                                  (_ctx.isExternal(item.href) && item?.name !== 'Academy' && item?.name !== 'Pub Menu' && item?.name !== 'Log Out')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: item.href
                                      }, _toDisplayString(item.label), 9, _hoisted_76))
                                    : (item?.name !== 'Academy' && item?.name !== 'Pub Menu' && item?.name !== 'Log Out')
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 1,
                                          to: item.href,
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.hideModal()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(item.label), 1))
                                ], 8, _hoisted_75))
                              }), 128))
                            ])
                          ], 8, _hoisted_73)
                        ], 64))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createVNode(_component_LoaderSpinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}